import withScroll from '../hoc/withScroll'
import onResize from '../utils/onResize'
import getOffset from '../utils/getOffset'
import instantsearch from 'instantsearch.js'
import algoliasearch from 'algoliasearch/lite'

import customHits from '../utils/algolia/customHits'
import { configure } from 'instantsearch.js/es/widgets'
import customMenuSelect from '../utils/algolia/customMenuSelect'
import customRefinementList from '../utils/algolia/customRefinementList'

export default withScroll({
  name: 'algolia-list',

  ui: {
    wrap: '[js-algolia-list-filters-wrap]',
    toggle: '[js-algolia-list-filters-toggle]',
    results: '[js-algolia-list-results]',
    filtersDropdown: '[js-algolia-list-filters-dropdown]',
    filtersSelect: '[js-algolia-list-filters-select]',
  },

  componentDidMount () {
    this.header = document.querySelector('.header')
    this.off = onResize(this.onResize.bind(this))
    this.wrapOffset = this.ui.wrap ? getOffset(this.ui.wrap) : 0
    this.headerHeight = this.header.offsetHeight
    this.toggleHeight = this.ui.toggle ? this.ui.toggle.offsetHeight : 0

    const indexName = `${config.algolia.env}_pages`

    this.searchClient = algoliasearch(
      config.algolia.applicationID,
      config.algolia.apiKey,
    )

    this.search = instantsearch({
      indexName: `${indexName}`,
      searchClient: this.searchClient,
    })

    this.search.addWidgets([
      // global
      configure({
        hitsPerPage: this.props.type === 'news' ? 6 : 500,
        filters: `locale:${config.locale} AND visible:true AND type:${this.props.type}`,
      }),
      // results
      customHits({
        container: this.ui.results,
        type: this.props.type,
      }),
    ])

    const isNews = this.props.type === 'news'

    if (this.ui.filtersDropdown) {
      this.search.addWidgets([
        customRefinementList({
          container: this.ui.filtersDropdown,
          attribute: this.ui.filtersDropdown.dataset.type,
          sortBy: ['name'],
          isNews: isNews,
        }),
      ])

      this.ui.toggle.addEventListener('click', () => {
        this.ui.filtersDropdown.classList.toggle('is-active')
        this.ui.toggle.classList.toggle('is-active')
      })

      document.body.addEventListener('click', (e) => {
        if (!e.target.closest('.filters')) {
          this.ui.filtersDropdown.classList.remove('is-active')
          this.ui.toggle.classList.remove('is-active')
        }
      })
    }

    if (this.ui.filtersSelect) {
      this.search.addWidgets([
        // selectMenu
        customMenuSelect({
          container: this.ui.filtersSelect,
          attribute: this.ui.filtersSelect.dataset.type,
          type: this.props.type,
          sortBy: ['name:desc'],
        }),
      ])
    }

    this.search.start()
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.wrapOffset = this.ui.wrap ? getOffset(this.ui.wrap) : 0
  },

  onScroll ({ y }) {
    if (window.innerWidth < 768 && this.ui.toggle) {
      if (y > this.wrapOffset - this.headerHeight + this.toggleHeight) {
        this.ui.toggle.parentNode.classList.add('is-fixed')
        this.header.classList.add('has-no-shadow')
      } else {
        this.ui.toggle.parentNode.classList.remove('is-fixed')
        this.header.classList.remove('has-no-shadow')
      }
    } else {
      this.header.classList.remove('has-no-shadow')
    }
  },
})
